import AlertHistoryPage from "./AlertHistoryPage";

export default AlertHistoryPage;
